(() => {
  document.querySelectorAll('[data-acy-comparison]').forEach((section) => {
    const stage = section.querySelector('.acy-v16-comparison__stage');
    const input = section.querySelector('input[type="range"]');
    if (!stage || !input) return;
    const update = () => stage.style.setProperty('--compare-position', `${input.value}%`);
    input.addEventListener('input', update, { passive: true });
    update();
  });
})();
